export const intervalApiCateringCall = 48000;
export const pageBackFlippingDuration = 12000;
